export const imprintData = {
  title: 'Imprint',
  sections: [
    {
      title: 'Information pursuant to § 5 TMG',
      content: [
        'Robin Wichmann',
        'Hauptstr. 58c',
        '21640 Bliedersdorf'
      ]
    },
    {
      title: 'Contact',
      content: [
        'E-mail: kontakt@robinwichmann.com'
      ]
    },
    {
      title: 'VAT ID',
      content: [
        'VAT identification number pursuant to § 27 a Umsatzsteuergesetz:',
        'DE304417567'
      ]
    },
    {
      title: 'Responsible for content pursuant to § 55 Abs. 2 RStV',
      content: [
        'Robin Wichmann',
        'Hauptstr. 58c',
        '21640 Bliedersdorf'
      ],
      type: 'address'
    },
    {
      title: 'Disclaimer',
      content: [
        'The following notes provide an overview of the legal framework of this website. This English translation is provided for convenience; the German version is legally binding.'
      ],
      subsections: [
        {
          title: 'Liability for content',
          content: [
            'The content of this website has been created with the greatest care.',
            'However, we cannot guarantee the accuracy, completeness, or timeliness of the content.',
            'As a service provider, we are responsible for our own content on these pages pursuant to § 7 Abs.1 TMG.',
            'Third-party content is only reviewed when there is concrete suspicion of a legal violation.'
          ]
        },
        {
          title: 'Liability for links',
          content: [
            'Our website contains links to external third-party websites over whose content we have no influence.',
            'Therefore, we accept no liability for this external content.',
            'No legal violations were apparent at the time the links were created.',
            'If we become aware of any legal violations, we will remove the links immediately.'
          ]
        },
        {
          title: 'Copyright',
          content: [
            'The content of this website is subject to German copyright law.',
            'All rights reserved.',
            'Reproduction, editing, or exploitation of the content requires the express consent of the respective author.',
            'If you believe there is a copyright violation, please let us know.'
          ]
        }
      ]
    }
  ]
};
